<i18n>
{
    "uk": {
        "map": {
            "single": {
                "title": "Цей курс входить в карту навчання «{name}»",
                "text": "Радимо ознайомитись з цією картою, щоб ліпше спланувати своє навчання. Також за допомогою карти ви зможете переконатись, що ви готові до проходження цього курсу.",
                "btn": "До карти"
            },
            "multiple": {
                "title": "Цей курс входить в  декілька карт навчання",
                "text": "Радимо ознайомитись з картами, щоб ліпше спланувати свій план навчання. Також за допомогою карт ви зможете переконатись, що ви готові до проходження цього курсу.",
                "links": "Пов’язані з курсом карти: "
            }
        }
    },
    "en": {
        "map": {
            "single": {
                "title": "This course included in the learning map \"{name}\"",
                "text": "It's recommended to take a look on this map for better learning planning. Also, with the map, you can be sure that you are ready to take this course.",
                "btn": "To the map"
            },
            "multiple": {
                "title": "This course included in a multiple learning maps",
                "text": "It's recommended to take a look on this maps for better learning planning. Also, with the maps, you can be sure that you are ready to take this course.",
                "links": "Maps related to the course: "
            }
        }
    }
}
</i18n>


<template>
    <div v-if="maps.length" class="page-container">
        <Card :lower="true" class="maps-card mt-6 mt-md-8 mt-lg-10 p-lg-6" :class="block.class">
            <svg class="tip-path" width="1034" height="98" viewBox="0 0 1034 98" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 21.4964C86.8749 6.78395 287.639 -13.8134 403.695 21.4964C548.765 65.6336 604.793 96 697.337 96C789.882 96 897.935 38.016 1033 50.7275" stroke="#EB6772" stroke-opacity="0.15" stroke-width="4" stroke-dasharray="8 8"/>
            </svg>

            <div class="tip-pic mr-4 mr-md-5 tip-content d-none d-sm-flex">
                <WebpPicture
                    :src="iconSrc"
                    alt=""
                    loading="lazy"
                    width="150"
                    height="150"
                    class="pic"
                    :class="{single: maps.length == 1}"
                />
            </div>

            <div class="tip-content" v-if="maps.length == 1">
                <h2 class="h3 fw-800 h-black m-0">
                    {{ $t('map.single.title', {name: maps[0].title[locale]}) }}
                </h2>

                <div class="my-3">
                    {{ $t('map.single.text') }}
                </div>

                <div class="d-flex">
                    <nuxt-link
                        :to="localePath(`/learning/map/${maps[0].slug}`)"
                        class="btn-primary mr-2 fw-600"
                    >
                        <span class="icon-ic-map mr-1 color-gray-3" /> {{ $t('map.single.btn') }}
                    </nuxt-link>
                </div>
            </div>
            <div v-else class="tip-content">
                <h2 class="h3 fw-800 h-black m-0">
                    {{ $t('map.multiple.title') }}
                </h2>

                <div class="my-3">
                    {{ $t('map.multiple.text') }}
                </div>

                <div class="mb-1 fw-700">
                    {{ $t('map.multiple.links') }}
                </div>

                <div class="chips">
                    <nuxt-link
                        :to="localePath(`/learning/map/${map.slug}`)"
                        v-for="map in maps"
                        :key="map.id"
                        class="chip chip-container colored blue fw-600 linked"
                    >
                        <div class="chip-text">{{ map.title[locale] }}</div>
                    </nuxt-link>
                </div>
            </div>
        </Card>
    </div>
</template>


<script>
    import Card        from '~/components/cards/Card.vue';
    import WebpPicture from '~/components/WebpPicture.vue';

    import { useCourseLandingStore } from '~/stores/courseLanding';

    export default {
        props: {
            block: Object,
        },

        components: {
            Card,
            WebpPicture,
        },

        computed: {
            locale () {
                return this.courseLandingStore.locale;
            },

            maps () {
                return this.courseLandingStore.maps;
            },

            courseLandingStore () {
                return useCourseLandingStore();
            },


            iconSrc () {
                let src = 'https://cdn.cases.media/image/original/cp-learning-maps-multiple-icon.png';

                if (this.maps.length == 1 && this.maps[0]?.icon) {
                    src = this.maps[0].icon;
                }

                return src;
            },
        },
    };
</script>


<style lang="postcss" scoped>
    .tip-pic {
        flex-shrink: 0;
        align-items: center;
        justify-content: center;

        padding: 16px;
        border-radius: 50%;
        background-color: var(--color-control);
        height: 120px;
        width: 120px;

        .pic,
        .pic :deep(img) {
            width:  120px;
            height: auto;
        }

        @media screen and (min-width: 992px) {
            padding: 32px;
            width:   200px;
            height:  200px;

            .pic,
            .pic :deep(img) {
                width:  150px;
                height: auto;
            }

            .pic.single,
            .pic.single :deep(img) {
                width:  124px;
                height: auto;
            }
        }
    }

    .tip-path {
        position: absolute;
        top: 40%;
        left: 0;
        right: 0;
        z-index: 0;
    }

    .tip-content {
        position: relative;
    }

    .maps-card {
        display: flex;
        overflow: hidden;
        align-items: flex-start;
        position: relative;
        background: radial-gradient(53.85% 75.89% at 85.48% 100%, #FFF9E0 0%, rgba(255, 235, 237, 0) 100%),
                    linear-gradient(180deg, #FFEBED 0%, #F1EBFF 100%),
                    #FFEBED;
    }

    @media (prefers-color-scheme: dark) {
        .maps-card {
            background: radial-gradient(53.85% 75.89% at 85.48% 100%, #595540 0%, rgba(255, 235, 237, 0) 100%),
                        linear-gradient(180deg, #4b3033 0%, #2b2243 100%),
                        #424032;

            .icon {
                mix-blend-mode: screen;
            }
        }
    }

    [data-theme='dark'] {
        .maps-card {
            background: radial-gradient(53.85% 75.89% at 85.48% 100%, #595540 0%, rgba(255, 235, 237, 0) 100%),
                        linear-gradient(180deg, #4b3033 0%, #2b2243 100%),
                        #424032;

            .icon {
                mix-blend-mode: screen;
            }
        }
    }

    [data-theme='light'] {
        .maps-card {
            background: radial-gradient(53.85% 75.89% at 85.48% 100%, #FFF9E0 0%, rgba(255, 235, 237, 0) 100%),
                        linear-gradient(180deg, #FFEBED 0%, #F1EBFF 100%),
                        #FFEBED;

            .icon {
                mix-blend-mode: multiply;
            }
        }
    }
</style>
